<main class="container" [class.mobile]="isMobile$ | async">
  <div class="content">
    <router-outlet></router-outlet>
  </div>
</main>
